import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { CustomerApi } from '_api';
import { FIELD_KEYS } from '_constants/forms';
import { handleError } from '_helpers/api';
import { getOrder } from '_store/order/slice';

export const updateTaxFilingInfo = createAsyncThunk(
  'taxFilingInfo/update',
  async function ({ customerId, orderId, productId, body }, { dispatch, rejectWithValue }) {
    try {
      await CustomerApi.updateProduct({ customerId, productId, body });
      toast.success('Information was updated successfully!');
      dispatch(getOrder({ customerId, orderId }));
    } catch (error) {
      const processedError = handleError(error);
      return rejectWithValue(processedError);
    }
  }
);

const initialForm = {
  [FIELD_KEYS.firstName]: '',
  [FIELD_KEYS.lastName]: '',
  [FIELD_KEYS.ssn]: '',
  [FIELD_KEYS.dateOfBirth]: new Date(),
  [FIELD_KEYS.email]: '',
  [FIELD_KEYS.phone]: '',
  [FIELD_KEYS.address1]: '',
  [FIELD_KEYS.zip]: '',
  [FIELD_KEYS.city]: '',
  [FIELD_KEYS.state]: '',
  [FIELD_KEYS.spouse]: 'no',
  [FIELD_KEYS.spouseFirstName]: '',
  [FIELD_KEYS.spouseLastName]: '',
  [FIELD_KEYS.spouseSsn]: '',
  [FIELD_KEYS.spouseDateOfBirth]: new Date(),
  [FIELD_KEYS.spouseEmail]: '',
  [FIELD_KEYS.spousePhone]: '',
  [FIELD_KEYS.spouseAddress1]: '',
  [FIELD_KEYS.spouseZip]: '',
  [FIELD_KEYS.spouseCity]: '',
  [FIELD_KEYS.spouseState]: '',
  [FIELD_KEYS.dependents]: [],
  [FIELD_KEYS.status]: null,
  [FIELD_KEYS.marriedFilingSeparately]: null,
  [FIELD_KEYS.filingSingle]: 'single',
};

const taxFilingInfoSlice = createSlice({
  name: 'taxFilingInfo',
  initialState: {
    form: {
      ...initialForm,
    },
    data: {},
    error: null,
    loading: false,
  },
  reducers: {
    refreshForm(state, action) {
      state.form = {
        ...state.form,
        ...action.payload,
      };
    },
    resetForm(state) {
      state.form = {
        ...initialForm,
      };
    },
    resetError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateTaxFilingInfo.pending, (state) => {
        state.error = null;
        state.loading = true;
      })
      .addCase(updateTaxFilingInfo.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(updateTaxFilingInfo.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export const { refreshForm, resetForm, resetError } = taxFilingInfoSlice.actions;

export default taxFilingInfoSlice.reducer;
